import { Injectable } from '@angular/core';
import { EnvironmentService } from './core/services/environment.service';
import { ApiEndpointService } from './core/services/api-endpoint.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PreLoadService {

    private disclaimerSubject = new BehaviorSubject<boolean>(false);
    disclaimer$ = this.disclaimerSubject.asObservable();
    setDisclaimer(value: boolean): void {
        this.disclaimerSubject.next(value);
    }
    constructor(private environmentService: EnvironmentService,
        private apiEndpointService: ApiEndpointService, ) {


    }

    load() {

        return new Promise((resolve, reject) => {
            this.environmentService.initEnvironment()
                .subscribe(
                    (env) => {
                        if (!env) {
                            return;
                        }                        
                        this.apiEndpointService.constructEndpoints(env);
                        resolve(true);
                    },
                    (err) => {
                        console.error('Failed initializing environment.', err);
                    },
            );
        });


    }

}